import { Icon } from '@iconify/react';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, IconButton, Stack } from '@mui/material';
//
import Logo from '@components/Logo';
import ROUTES from 'routes/paths';
import APP_CONFIG from '@config';

// ----------------------------------------------------------------------

const SOCIALS = [{ name: 'FaceBook', icon: facebookFill, link: 'https://facebook.com/ITPTIT' }];

const LINKS = [
  {
    headline: 'Links',
    children: [
      { name: 'Về chúng tôi', href: ROUTES.ABOUT },
      { name: 'Liên hệ', href: ROUTES.CONTACT },
      { name: 'FAQs', href: `${ROUTES.HOME}#faq` },
    ],
  },
  {
    headline: 'Liên hệ',
    children: [
      { name: 'clb.it.ptit@gmail.com', href: 'mailto:clb.it.ptit@gmail.com' },
      { name: '+84 356958883', href: 'tel:+84356958883' },
      { name: 'Học viện Công Nghệ Bưu Chính Viễn Thông' },
    ],
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

const TextStyle = styled('span')(({ theme }) => ({
  color: `${theme.palette.primary.main} !important`,
  '&:hover': {
    opacity: 0.48,
    textDecoration: 'none',
  },
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <RootStyle>
      <Divider />
      <Container maxWidth="lg" sx={{ pt: 10 }}>
        <Grid container justifyContent={{ xs: 'center', md: 'space-between' }} sx={{ textAlign: { xs: 'center' } }}>
          <Grid item xs={8} md={3}>
            <Grid item xs={12} sx={{ mb: 3 }}>
              <ScrollLink to="move_top" spy smooth>
                <Logo sx={{ mx: { xs: 'auto' } }} />
              </ScrollLink>
            </Grid>
            <Typography variant="body2">ITPTIT - Mãi là anh em</Typography>

            <Stack spacing={1.5} direction="row" justifyContent={{ xs: 'center' }} sx={{ mt: 3, mb: { xs: 5, md: 0 } }}>
              {SOCIALS.map((social) => (
                <IconButton key={social.name} color="primary" sx={{ p: 1 }} href={social.link} target="_blank">
                  <Icon icon={social.icon} width={16} height={16} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => {
                const { headline, children } = list;
                return (
                  <Stack key={headline} spacing={2}>
                    <Typography component="p" variant="overline">
                      {headline}
                    </Typography>
                    {children.map((link) => (
                      <Link
                        to={link.href}
                        href={link.href}
                        key={link.name}
                        color="inherit"
                        variant="body2"
                        component={link?.href?.startsWith('/') ? RouterLink : undefined}
                        sx={{ display: 'block' }}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </Stack>
                );
              })}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center' },
          }}
        >
          {`©${currentYear} `}
          <RouterLink to={ROUTES.DASHBOARD_ROOT} style={{ textDecoration: 'none' }}>
            <TextStyle
              sx={{
                color: 'text.primary',
                '&.active': {
                  color: 'primary.main',
                },
              }}
            >
              {APP_CONFIG.siteName}
            </TextStyle>
          </RouterLink>
          . All rights reserved
        </Typography>
      </Container>
    </RootStyle>
  );
}
